import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { Text, TextMarkup } from '../../text';
/**
 * Selector Item Component
 * @param active {boolean} active tab item
 * @param children {ReactChild} React Child Element
 * @param onClick onClick Event
 * @param inverted {boolean} change style to inverted item
 * @param end {boolean} Change last SelectorItem style to SECONDAY color
 * - -------------------------- WEB PROPERTIES -------------------------------
 * @param className {string} Additionnal CSS Classes
 */
const SelectorItem = ({ active, children, className, onClick, ...others }) => {
    const [activeItem, setActiveItem] = useState(active || false);
    // TODO: Update react component when web component (CSS) is ready
    // accessibility
    const a11y = {
        li: {
            role: 'presentation',
        },
        a: {
            role: 'selector',
            'aria-selected': activeItem,
        },
    };
    useEffect(() => {
        setActiveItem(active || false);
    }, [active]);
    return (React.createElement("li", { className: clsx(className, { 'is-active': activeItem }), ...a11y.li, ...others, onClick: (e) => {
            const target = e.target;
            setActiveItem(active || false);
            target.active = active;
            if (onClick) {
                onClick(e);
            }
        } }, children && typeof children.valueOf() === 'string' && (React.createElement(Text, { markup: TextMarkup.A, ...a11y.a, ...others }, String(children)))));
};
export default SelectorItem;
//# sourceMappingURL=SelectorItem.js.map